import { CobaltPageHeader } from '@cae/cobalt-react/components/page-header';
import { useInstructorsData } from '@features/instructors/contexts/data/useInstructorsData';
import { useInstructorsFilter } from '@features/instructors/contexts/filter/useInstructorsFilter';
import * as React from 'react';

import { InstructorsFilterPanel } from '../filter-panel/InstructorsFilterPanel';
import { InstructorActionTiles } from './actions-tiles/InstructorActionTiles';
import { InstructorsFilterButton } from './filter-button/InstructorsFilterButton';
import styles from './InstructorsHeader.module.css';
import { InstructorsSearch } from './search/InstructorsSearch';

const InstructorsHeader = React.memo((): React.ReactElement => {
  const [isFiltersPanelOpen, setIsFiltersPanelOpen] =
    React.useState<boolean>(false);
  const { instructors } = useInstructorsData();
  const { isFiltersApplied, isSearchApplied } = useInstructorsFilter();

  const controlsDisabled =
    instructors.isLoading ||
    (instructors.data.total === 0 && !isFiltersApplied && !isSearchApplied);

  const handleFiltersOpen = React.useCallback((): void => {
    setIsFiltersPanelOpen(true);
  }, []);

  const handleFiltersClose = React.useCallback((): void => {
    setIsFiltersPanelOpen(false);
  }, []);

  return (
    <section data-testid="instructors-header" className={styles.stickyWrapper}>
      <CobaltPageHeader
        title="Instructor management"
        className={styles.header}
        content={
          <div
            data-testid="instructors-header-content"
            className={styles.headerContent}
          >
            <InstructorActionTiles />
            {!controlsDisabled && (
              <div className={styles.headerSearchAndFiltersActions}>
                <InstructorsSearch />
                <InstructorsFilterButton onFiltersOpen={handleFiltersOpen} />
              </div>
            )}
          </div>
        }
      />
      {isFiltersPanelOpen && (
        <InstructorsFilterPanel onClose={handleFiltersClose} />
      )}
    </section>
  );
});

InstructorsHeader.displayName = 'InstructorsHeader';
export { InstructorsHeader };
